import { InjectionToken, NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { ActionReducerMap, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { RecentSearchesFacade } from '@recent-searches/store/recent-searches.facade';
import { RecentService } from '@recent-searches/services/recent.service';
import {
  recentSearchesFeatureName, RecentSearchesModuleState
} from '@recent-searches/store/state/recent-searches.state';
import { recentSearchesRootReducer } from '@recent-searches/store/reducers';
import { GlobalPipesModule } from '@app/pipes/global-pipes.module';
import { RecentSearchesEffect } from '@recent-searches/store/effects/recent-searches.effects';
import { RecentSearchesContainer } from '@recent-searches/recent-searches.container';
import { RecentSearchesPipe } from '@recent-searches/pipes/searches.pipe';
import { SlidersModule } from '@shared/sliders/sliders.module';
import { TooltipDirectiveModule } from '@ux/directives/tooltip/tooltip-directive.module';
import {
  AirPackageRecentSearchComponent
} from '@recent-searches/components/air-package-recent-search/air-package-recent-search.component';
import { SlideRecentComponent } from '@recent-searches/components/slide-recent-search/slide-recent.component';
import { AirRecentSearchComponent } from '@recent-searches/components/air-recent-search/air-recent-search.component';
import { CarsRecentSearchComponent } from '@recent-searches/components/cars-recent-search/cars-recent-search.component';
import { HotelRecentSearchComponent } from '@recent-searches/components/hotel-recent-search/hotel-recent-search.component';
import { BusRecentSearchComponent } from '@recent-searches/components/bus-recent-search/bus-recent-search.component';
import { RecentSearchDsComponent } from '@design-system/components/molecules/recent-search/recent-search.component';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';
import { ButtonLinkDsComponent } from '@design-system/components/molecules/button-link/button-link.component';
import { ButtonIconDsComponent } from '@design-system/components/molecules/button-icon/button-icon.component';

export const FEATURE_REDUCER_TOKEN = new InjectionToken
  <ActionReducerMap<RecentSearchesModuleState>>('Feature Recent Searches Reducers');

@NgModule({
  declarations: [
    RecentSearchesContainer,
    RecentSearchesPipe,
    AirPackageRecentSearchComponent,
    SlideRecentComponent,
    AirRecentSearchComponent,
    CarsRecentSearchComponent,
    HotelRecentSearchComponent,
    BusRecentSearchComponent,
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    GlobalPipesModule,
    StoreModule.forFeature(recentSearchesFeatureName, FEATURE_REDUCER_TOKEN),
    EffectsModule.forFeature([RecentSearchesEffect]),
    SlidersModule,
    TooltipDirectiveModule,
    RecentSearchDsComponent,
    TypographyDsComponent,
    ButtonLinkDsComponent,
    ButtonIconDsComponent
  ],
  exports: [
    RecentSearchesContainer
  ],
  providers: [
    RecentSearchesFacade,
    DatePipe,
    RecentService,
    RecentSearchesPipe,
    {
      provide: FEATURE_REDUCER_TOKEN,
      useValue: recentSearchesRootReducer
    },
  ]
})
export class RecentSearchesModule { }
